// extracted by mini-css-extract-plugin
export default {"productGallery":"lH-z","inQuickShop":"mH-z"};